import axios from "axios";
import { isLocalhost } from "../../checkLocalhost";

// 1. Define the base configuration
const getBaseURL = () => isLocalhost
    ? import.meta.env.VITE_DSERVER_BASEURL + import.meta.env.VITE_API
    : import.meta.env.VITE_SH_DSERVER_BASEURL + import.meta.env.VITE_SH_API;

// 2. Create the instance with a default function
const apiRequest = (options = {}) => {
  // Destructure 'credentials' from options, defaulting to true if not provided
  const { credentials = true, ...axiosOptions } = options;

  return axios.create({
    baseURL: getBaseURL(),
    withCredentials: credentials, // Use the parameter
    ...axiosOptions
  });
};

// 3. To maintain backward compatibility with your existing imports:
// We create a default instance that behaves like your original code.
const defaultInstance = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

// Add a helper method to the default instance for conditional calls
defaultInstance.withConfig = (credentials = true) => {
    return axios.create({
        baseURL: getBaseURL(),
        withCredentials: credentials
    });
};

export default defaultInstance;